<template>
  <div>
    <audio ref="auido" src=""></audio>
    <div class="page_main flex-col">
      <div class="pos_row flex-col">
        <div style="border-radius: 10px;margin-bottom: 10px;background-color: antiquewhite;">
          <span>【{{ nickname }} {{ phone }}】 @【{{ pos.pos.name }}】</span>
        </div>
        <div class="flex-row justify-between align-center">
          <span class="pos_label">用户详细信息</span>
          <van-button class="button" plain type="info" @click="hiddenTable('showUserDetail')">隐藏/显示</van-button>
        </div>
        <div v-show="showUserDetail">
          <div>
            <table class="user_detail_table">
              <thead>
              <tr>
                <th></th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <th>当前用户</th>
                <td>{{ nickname }}</td>
              </tr>
              <tr class="user_row">
                <th class="th_left">位置</th>
                <td class="td_right">距离门店
                  <span v-if="user.position">{{ user.position }}</span>
                  <span v-else>未知距离</span>
                </td>
              </tr>
              <tr>
                <th>手机</th>
                <td>{{ user.phone }}</td>
              </tr>
              <tr>
                <th>车牌</th>
                <td v-if="user.plateNum">{{ user.plateNum }}</td>
                <td v-else>暂无车牌</td>
              </tr>
              <tr>
                <th>链点</th>
                <td>{{ user.points }}</td>
              </tr>
              <tr>
                <th>默认服务</th>
                <td>{{ user.carWashMethod }}</td>
              </tr>
              <tr v-if="order">
                <th>订单信息<br />【{{ getOrderState(order.state) }}】</th>
                <td>
                  <table>
                    <thead>
                    <tr>
                      <td>商品</td>
                      <td>金额</td>
                      <td>备注</td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td>{{ order.name }}</td>
                      <td>￥{{ order.price }}</td>
                      <td>
                        <span v-if="order.points > 0">链点{{ order.points }}</span>
                        <span v-if="order.amount > 0">+微信￥{{ order.amount }}</span>
                        <span v-if="order.balnce > 0">+余额￥{{ order.balnce }}</span>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              </tbody>
            </table>
            <div class="flex_row input_row">
              <van-button
                v-for="item of buttons"
                :key="item.id"
                class="button service_button"
                plain
                type="info"
                @click="serviceButton(item.id)">{{ item.name }}
              </van-button>
            </div>
          </div>
        </div>
      </div>
      <div class="pos_row flex-col">
        <div class="label_row pos_label justify-start">当前会话消息：</div>
        <div id="session_container" class="session_container flex-col">
          <div v-for="item of msgList" :key="item.msgID" class="msg_row flex-column">
            <div class="flex-row">
              <span class="founder">{{ item.nickName }}：</span>
              <div class="flex-row align-center" v-if="item.audio">
                <van-button class="playRecord_button" @click="wxAudioRecord.playRecord(item.audio)">
                  <van-icon name="play-circle-o" size="30px" />
                </van-button>
                <span class="playRecord_text">{{ item.msg }}</span>
              </div>
              <span v-else class="msgText">{{ item.msg }}</span>
            </div>
            <div class="msg_timestamp flex-row justify-end">{{ convertUnixTimestamp(item.timestamp) }}</div>
          </div>
        </div>
        <el-select v-model="selectedCuePhrasesValue" placeholder="请选择要发送的提示语">
          <el-option
            v-for="item in sessionSelect"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
        <el-input v-model="inputCuePhrases" class="input_row" placeholder="请输入要发送的提示语"></el-input>
        <div class="add_page" @click="addPage">{{ currentPage.label }}</div>
        <div class="page_variable_container flex-col align-center" v-if="currentPage.id !== 0">
          <div class="flex-col align-center" v-if="pageVariables.length !== 0">
            <div class="flex-row align-center justify-between" v-for="item of pageVariables" :key="item.id"
                 style="margin-top: 10px">
              <el-input class="page_variable_name" v-model="item.name" placeholder="请填写参数名"></el-input>
              :
              <el-input class="page_variable_value" v-model="item.value" placeholder="请填写参数值"></el-input>
            </div>
          </div>
          <div class="add_page_variable" @click="addPageVariableRow">+ 新增页面后缀参数</div>
        </div>

        <div class="add_page" @click="addTimbre">{{ currentTimbre.label }}</div>

        <!--        <div>{{ currentTimbre }}</div>-->
        <el-button class="input_row" type="primary" @click="sendMsg(selectedCuePhrasesText)">发送消息</el-button>
        <recode-button
          style="margin-top: 12px"
          :getRecordText="getRecordText"
        >
        </recode-button>
      </div>

      <div class="pos_row flex-col">
        <div class="flex-row justify-between align-center">
          <span class="pos_label">门店服务记录：</span>
          <van-button class="button" plain type="info" @click="hiddenTable('showServiceList')">隐藏/显示</van-button>
        </div>
        <div v-show="showServiceList">
          <table>
            <thead>
            <tr>
              <td>时间</td>
              <td>内容</td>
              <td>状态</td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) of serviceList" :key="index">
              <td>{{ item.order.createTime }}</td>
              <td>
                <span v-for="(i,index) of item.lstProduct" :key="index">{{ i.name }}</span>
                <span v-if="item.order.plateNum">({{ item.order.plateNum }})</span>
              </td>
              <td>{{ item.state }}</td>
            </tr>
            </tbody>
          </table>
          <div v-if="serviceList.length === 0" class="nullServiceList justify-center">暂无数据</div>
        </div>
      </div>

      <div class="pos_row flex-col">
        <div class="flex-row justify-between align-center">
          <span class="pos_label">门店在售商品与服务：</span>
          <van-button class="button" plain type="info" @click="hiddenTable('showProductList')">隐藏/显示</van-button>
        </div>
        <div v-show="showProductList">
          <table>
            <thead>
            <tr>
              <td>商品</td>
              <td>价格</td>
              <td>选择</td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) of pos.lstProduct" :key="index">
              <td>{{ item.product.name }}</td>
              <td>￥{{ item.yuanPrice }}元</td>
              <td class="flex-row align-center justify-center">
                <input class="purchase_checkbox" type="checkbox">本次采购
              </td>
            </tr>
            </tbody>
          </table>
          <!--          <div class="productButton flex-row justify-end">
                      <el-button type="primary">代客下单，链点支付</el-button>
                    </div>-->
        </div>
      </div>


    </div>

  </div>
</template>

<script>
import {getOrderInfo, queryOrderByPosId, queryPosDetailByPosId, queryUserInfo, queryUserPoints} from "../graphql/api";
import {addEventLog, adminStartWash, getTTSToken, getUserEventLog, orderComplete, refund} from "../api";
import {mqttConnect, mqttPublish, setClientID} from "../util/mqttMonitor";
import {v4 as uuidv4} from 'uuid';
import {wxAudioRecord} from "../util/wxAudioRecord";
import RecodeButton from "../components/recodeButton.vue";
import {convertUnixTimestamp} from "../util";

export default {
  name: "pos_monitor_handler",
  components: {RecodeButton},
  data() {
    return {
      order: null,

      sessionText: '现场车牌识别可能失效，您需要退后您的车辆，再次尝试',
      showServiceList: true,
      showProductList: true,
      showUserDetail: true,
      nullProduct: false,
      msgList: [],

      points: '',
      yuanPoints: '',
      pos: {
        pos: {
          name: ''
        },
        state: '',
      },
      selectedCuePhrasesValue: 0, //被选中的提示语
      selectedCuePhrasesText: '现场车牌识别可能失效，您需要退后您的车辆，再次尝试',
      inputCuePhrases: "", //输入的提示语
      sessionSelect: [
        {
          id: 0,
          text: '现场车牌识别可能失效，您需要退后您的车辆，再次尝试'
        }, {
          id: 1,
          text: '小敏马上帮您启动洗车,请稍后'
        }, {
          id: 2,
          text: '请查看现场指示灯，确保指示灯为红色，三秒后将启动洗车'
        }, {
          id: 3,
          text: '网点机器故障，请到其他网点洗车'
        },
      ],
      serviceList: [],
      productList: [],
      buttons: [
        {
          id: 0,
          name: '无法服务，已退款'
        }, {
          id: 1,
          name: '请求机器人完成服务'
        }, {
          id: 2,
          name: '人工处理，已完成服务'
        }
      ],
      posImg: '',

      orderInfo: {},

      user: {
        position: "",
        nickName: "",
        phone: "",
        plateNum: "",
        points: "",
        carWashMethod: ""
      },

      unservedOrder: [{
        id: "",
        name: "",
        price: "",
        amount: "",
        points: "",
      }],

      cardList: [],  // 启动洗车的支付账户列表，有多个账户时管理需要进行选择
      showCardList: false,
      cardId: '',
      posId: null,
      orderId: null,
      nickname: null,
      phone: null,
      userAccount: null,

      currentPage: {
        id: 0,
        label: "点击添加页面",
        value: null
      },
      pageList: [{
        id: 0,
        label: "点击添加页面",
        value: null
      }, {
        id: 1,
        label: "首页",
        value: "ShopDiscover",
      }, {
        id: 2,
        label: "门店列表页",
        value: "ShopList"
      }, {
        id: 3,
        label: "门店推荐页",
        value: "PosRecommond",
      }, {
        id: 4,
        label: "门店详情页",
        value: "ShopDetail"
      }, {
        id: 5,
        label: "门店服务购买页",
        value: "ShopServicePurchase"
      }, {
        id: 6,
        label: "门店服务提醒页",
        value: "ShopServiceReminder"
      }, {
        id: 7,
        label: "我的",
        value: "Myself"
      }, {
        id: 8,
        label: "链点流水报表",
        value: "Points"
      }, {
        id: 9,
        label: "用户信息修改",
        value: "UserEdit"
      }, {
        id: 10,
        label: "修改手机号",
        value: "EditPhoneNum"
      }, {
        id: 11,
        label: "修改车牌",
        value: "EditPlate"
      }, {
        id: 12,
        label: "修改常用洗车模式",
        value: "EditMode"
      }, {
        id: 13,
        label: "修改发票抬头信息",
        value: "EditInvoiceDetail"
      }, {
        id: 14,
        label: "卡包",
        value: "UserCardBag"
      }, {
        id: 15,
        label: "订单记录",
        value: "OrderRecords"
      }, {
        id: 16,
        label: "订单详情",
        value: "OrderDetail"
      }, {
        id: 17,
        label: "订单核销二维码",
        value: "OrderVerifyQRCode"
      }, {
        id: 18,
        label: "意见反馈",
        value: "Questionnaire"
      }, {
        id: 19,
        label: "用户分享页",
        value: "TheCustomerShareImg"
      }, {
        id: 20,
        label: "门店评论页",
        value: "OrderComment"
      }, {
        id: 21,
        label: "链点购买页",
        value: "PointsRecharge"
      }, {
        id: 22,
        label: "设置敏仔指令",
        value: "EditMinzaiOrder"
      }],

      currentTimbre: {
        id: 0,
        label: "默认音色",
        value: null
      },
      timbres: [{
        id: 0,
        label: "默认音色",
        value: null
      }, {
        id: 1,
        label: "度逍遥（精品）",
        value: "5003"
      }, {
        id: 2,
        label: "度小鹿",
        value: "5118"
      }, {
        id: 3,
        label: "度博文",
        value: "106"
      }, {
        id: 4,
        label: "度小童",
        value: "110"
      }, {
        id: 5,
        label: "度小萌",
        value: "111"
      }, {
        id: 6,
        label: "度米朵",
        value: "103"
      }, {
        id: 7,
        label: "度小娇",
        value: "5"
      }],

      pageVariables: []
    }
  }
  ,
  computed: {
    wxAudioRecord() {
      return wxAudioRecord
    }
    ,
    // ...mapState(["userAllEventLog"])
  }
  ,
  watch: {
    selectedCuePhrasesValue: function () {
      for (const item of this.sessionSelect) {
        if (this.selectedCuePhrasesValue === item.id) {
          this.selectedCuePhrasesText = item.text;
        }
      }
    }
    ,
    inputCuePhrases: function () {
      if (this.inputCuePhrases === '' || this.inputCuePhrases.replace(/^\s*|\s*$/g, "") === "") {
        for (const item of this.sessionSelect) {
          if (this.selectedCuePhrasesValue === item.id) {
            this.selectedCuePhrasesText = item.text;
          }
        }
      } else {
        this.selectedCuePhrasesText = this.inputCuePhrases;
      }
    }
    ,
    posId: function (nv, ov) {
      console.log(nv, ov);
      this.posInfoInit();
    }
    ,
    orderId: function (nv, ov) {
      console.log(nv, ov);
      this.orderInfoInit();
    }
    ,
    userAccount: function (nv, ov) {
      console.log(nv, ov);
      this.findUserInfo();
    }
  }
  ,
  mounted() {
    console.log(this.$route.query);

    if (this.$route.query.userAccount == null) return;

    this.queryUserEventLog(this.$route.query.userAccount);

    this.userAccount = this.$route.query.userAccount;

    setClientID("omc-" + sessionStorage.getItem("openid") + "-" + sessionStorage.getItem("partnerid"))
    let topic = `ccnet/omc/#`
    mqttConnect(topic, this.mqttCallback, this.$route.query.userAccount);

    this.posId = this.$route.query.posId;

    this.orderId = this.$route.query.orderId;

    this.nickname = this.$route.query.nickname;

    this.phone = this.$route.query.phone

  }
  ,
  destroyed() {
    // mqttEnd();
    //sessionStorage.removeItem("currentMsg");
  }
  ,
  methods: {
    convertUnixTimestamp,

    //查询用户行为日志
    queryUserEventLog(openid) {
      let that = this;
      that.msgList = [];
      getUserEventLog(openid).then((res) => {
        console.log("查询用户操作日志:", res.data.data)
        let data = res.data.data[0].eventList;
        data.forEach(element => {
          let msg = {};
          if (!element.customerAccount) {
            if (element.describe) {
              msg = JSON.parse(element.describe);
            } else {
              msg.msg = element.event;
              if (element.event === "online") {
                msg.timestamp = element.timestamp
              }
            }
            msg.nickName = that.$route.query.nickname;
            that.msgList.push(msg);
          }
        });
        this.queryAdminEventLog();
      })
    }
    ,

    // 查询管理员操作日志
    queryAdminEventLog() {
      getUserEventLog(sessionStorage.getItem('openid')).then(res => {
        console.log('管理员操作日志', res)
        let data = res.data.data[0].eventList;
        data.forEach(item => {
          if (item.customerAccount && item.customerAccount === this.userAccount) {
            let msg = {};
            msg = JSON.parse(item.describe)
            msg.nickName = "管理员";
            this.msgList.push(msg);
          }
        });

        this.msgListSortByTime();
      }).catch(error => {
        console.log('查询管理员操作日志异常', error);
      })
    }
    ,

    // 根据时间对消息列表进行排序
    msgListSortByTime() {
      this.msgList.sort((a, b) => {
        return new Date(a.timestamp) - new Date(b.timestamp);
      })

      console.log('排序后的列表', this.msgList);
    }
    ,

    // 网点信息初始化
    posInfoInit() {
      if (this.posId) {
        this.queryPosInfo();
        this.getServiceList();
      }
    }
    ,

    // 查询网点详细信息
    queryPosInfo() {
      let params = {
        posId: this.posId
      }
      queryPosDetailByPosId(params).then(res => {
        console.log('当前门店是', res.data.findPosInfoByPosId);
        this.pos = res.data.findPosInfoByPosId;
        if (res.data.findPosInfoByPosId.posAdditionInfo && res.data.findPosInfoByPosId.posAdditionInfo.deliveryUrl) {
          this.posImg = res.data.findPosInfoByPosId.posAdditionInfo.deliveryUrl;
        }
        this.dataHandle(this.pos)
      }).catch(error => {
        alert(`查询网点信息异常${error}`);
      })
    }
    ,

    // 门店数据处理
    dataHandle(data) {
      if (data.lstProduct !== null) {
        for (const item of data.lstProduct) {
          let yuanPrice = ((item.realPrice) / 100).toFixed(2);
          this.$set(item, 'yuanPrice', yuanPrice);
        }
      } else {
        this.nullProduct = true
      }

      const {state} = data.pos;
      if (state == 1 || state == 100) {
        this.$set(data, "workState", "正常营业")
      } else if (state == 150 || state == 200 || state == 300) {
        this.$set(data, "workState", "工作中")
      } else if (state == 3) {
        this.$set(data, "workState", "维护")
      } else if (state == 4) {
        this.$set(data, "workState", "停业")
      } else if (state == 2 || state == 0) {
        this.$set(data, "workState", "离线")
      } else if (state == 400) {
        this.$set(data, "workState", "故障")
      }
    }
    ,

    getOrderState(completeState) {
      let stateStr = ["未支付", "待服务", "已完成", "已退款"];
      return stateStr[completeState - 1];
    }
    ,

    // 查询网点服务记录
    getServiceList() {
      let params = {
        posId: this.posId,
        page: 1,
        size: 10
      }

      queryOrderByPosId(params).then(res => {
        if (res.data.findOrderByPosId) {
          this.serviceList = res.data.findOrderByPosId;
          for (const item of this.serviceList) {
            if (item.order.completeState === 1) {
              this.$set(item, "state", "未支付");
            } else if (item.order.completeState === 2) {
              this.$set(item, "state", "已支付，待服务");
            } else if (item.order.completeState === 3) {
              this.$set(item, "state", "完成");
            } else if (item.order.completeState === 4) {
              this.$set(item, "state", "已退款");
            }
          }
        }
      }).catch(error => {
        alert(`查询网点服务记录异常${error}`);
      })
    }
    ,

    // 用户信息初始化
    orderInfoInit() {
      if (this.orderId) {
        this.queryOrderInfo(this.orderId);
      }
    }
    ,

    // 查询订单信息
    queryOrderInfo(orderId) {
      let params = {
        orderId: orderId
      }
      getOrderInfo(params).then(res => {
        console.log('查到的订单信息', res);
        if (res.data.queryOrderInfo[0]) {
          let data = res.data.queryOrderInfo[0];
          let price = Number((data.order.pointsPay + data.order.amount + data.order.balancePay) / 100).toFixed(2)
          this.order = {
            name: data.o2pList[0].productName,
            price: price,
            points: data.order.pointsPay,
            amount: Number(data.order.amount / 100).toFixed(2),
            balnce: Number(data.order.balancePay / 100).toFixed(2),
            state: data.order.completeState
          }
        }
      }).catch(error => {
        alert(`查询订单异常${error}`)
      })
    }
    ,

    // 查询用户信息
    findUserInfo() {
      if (this.userAccount == null) return;

      let userAccount = this.userAccount;
      // 查询用户详细信息
      queryUserInfo(userAccount).then(res => {
        console.log('查询用户信息');
        let data = res.data.findUserByUserAccount;

        let carWashMethod;
        if (data.carWashMethod === 4) {
          carWashMethod = "快洗"
        } else if (data.carWashMethod === 2) {
          carWashMethod = "精洗"
        } else if (data.carWashMethod === 1) {
          carWashMethod = "快洗"
        } else {
          carWashMethod = "未设置"
        }
        // 查询用户链点
        queryUserPoints(userAccount).then(res1 => {
          if (res1.data.findOnePoints) {
            this.points = res1.data.findOnePoints.points;
            this.yuanPoints = (this.points / 100).toFixed(2)
          } else {
            this.points = 0;
          }

          this.user = {
            nickName: res.data.findUserByUserAccount.nickName,
            userAccount: this.userAccount,
            phone: this.phone,
            plateNum: res.data.findUserByUserAccount.plateNum,
            points: this.points,
            carWashMethod: carWashMethod
          }

          console.log(this.user);
        }).catch(error => {
          alert(`查询用户链点异常${error}`)
        })
      }).catch(error => {
        alert(`查询用户信息异常${error}`)
      });
    }
    ,

    // 隐藏、显示表格
    hiddenTable(value) {
      console.log('value', value);
      if (value === 'showServiceList') {
        this.showServiceList = !this.showServiceList
      } else if (value === 'showProductList') {
        this.showProductList = !this.showProductList
      } else if (value === 'showUserDetail') {
        this.showUserDetail = !this.showUserDetail
      }
    }
    ,


    // 接收MQTT消息
    mqttCallback(message) {
      console.log(message);
      this.msg = message;

      if (this.msg.msgType === 'user_record') {wxAudioRecord.playRecord(this.msg.msg)}

      let parase = JSON.parse(this.msg.jsonParase)
      if (parase.pageVariables.orderId) this.orderId = parase.pageVariables.orderId;
      if (parase.pageVariables.posId) this.posId = parase.pageVariables.posId;
      if (parase.position) this.user.position = parase.position;

      this.msgList.push(this.msg);
      let element = document.getElementById('session_container');
      element.scrollTop = element.scrollHeight + element.clientHeight;
    }
    ,

    // 发送消息
    sendMsg(adminMsg) {
      console.log('admin', adminMsg);
      if (adminMsg === '' || adminMsg.replace(/^\s*|\s*$/g, "") === "") {
        alert('请输入要发送的消息！')
      } else {

        console.log('this.posId', this.posId);
        let jsonParase = {
          page: "",
          pageVariables: {}
        };

        if (this.currentPage && this.currentPage.id !== 0) {
          jsonParase.page = this.currentPage.value
        }


        if (Object.keys(this.pageVariables).length !== 0) {
          console.log('this.pageVariables', this.pageVariables);
          for (const item of this.pageVariables) {
            console.log('当前参数', item);
            this.$set(jsonParase.pageVariables, item.name, item.value)
          }
        }

        let msg = {
          msgID: uuidv4(),
          msgType: "chat_msg",
          timestamp: Math.floor(Date.now() / 1000).toString(),
          from: 'omc',
          to: 'user',
          nickName: '管理员',
          userAccount: sessionStorage.getItem('openid'),
          msg: adminMsg,
          jsonParase: JSON.stringify(jsonParase)
        }

        if (this.currentTimbre.value) {
          msg.ttsTimbre = this.currentTimbre.value
        }

        let topic = `ccnet/user/${this.userAccount}`
        console.log(topic);
        console.log('发送的消息', msg);
        mqttPublish(topic, msg);
        this.msgList.push(msg);
        let element = document.getElementById('session_container');

        if (element && element.scrollHeight) {
          element.scrollTop = element.scrollHeight + element.clientHeight;
        }

        this.AddCCLog(msg);

        this.currentPage = {
          id: 0,
          label: "点击添加页面",
          value: null
        }

        this.pageVariables = []
      }
    }
    ,

    AddCCLog(msg) {
      let params = {
        timestamp: Math.floor(Date.now() / 1000).toString(),
        event: "CC Message",
        posId: this.posId,
        customerAccount: this.userAccount,
        describe: JSON.stringify(msg),
        orderId: this.orderId
      }
      addEventLog(params).then(res => {
        console.log('添加管理员操作日志成功', res);
      }).catch(error => {
        console.log('添加管理员操作日志失败', error);
      });
    }
    ,

    // 服务按钮组(事件委托)
    serviceButton(id) {
      // 退款
      if (id === 0) {
        let params = {
          orderId: this.orderId
        }
        refund(params).then(res => {
          console.log('调退款接口响应拦截', res);
          if (res.data.retcode === 0) {
            alert('退款成功')
          } else {
            alert(`${res.data.retmsg}`)
          }
        }).catch(error => {
          alert(`退款失败${error}`)
        })

        // 管理员启动洗车
      } else if (id === 1) {
        let params = {
          orderId: this.orderId
        };
        adminStartWash(params).then(res => {
          console.log('启动洗车响应拦截', res);
          if (res.data.retcode === 0) {
            alert('启动洗车机成功')
          } else {
            alert(`${res.data.retmsg}`)
          }
        }).catch(error => {
          alert(`启动洗车失败${error}`)
        })

        // 管理员确认订单完成
      } else if (id === 2) {
        orderComplete(this.orderId).then(res => {
          console.log('确认订单完成', res);
          if (res.data.retcode === 0) {
            alert('管理员确认订单完成成功')
          } else {
            alert(`${res.data.retmsg}`)
          }
        }).catch(error => {
          alert(`确认订单失败${error}`)
        })
      }
    }
    ,

    // 确认支付账户
    confirmCard() {
      if (this.cardId !== "") {
        let params;
        if (this.pos.pos.fromnode === "automan") {
          params = {
            orderId: this.orderId,
            payMethod: 0,  //小猫只有手工启动
            cardId: this.cardId
          }
        } else if (this.pos.pos.partnerId === "M202304240014") {
          params = {
            orderId: this.orderId,
            payMethod: 1,  //易捷只有自动启动
            cardId: this.cardId
          }
        }
        console.log('传递的参数是', params);
        this.adminStartWash(params)
      } else {
        this.$dialog({
          title: '提醒',
          message: '请选择支付账户!'
        }).then(res => {
          this.showCardList = true;
        })
      }
    }
    ,

    // 播放语音
    payRecord(msg) {
      wxAudioRecord.playRecord(msg)
    }
    ,

    // 提取录音的文字
    getRecordText(text) {
      this.inputCuePhrases = text;
    }
    ,

    // 选择页面
    addPage() {
      let that = this;
      this.$weui.picker(
        that.pageList,
        {
          className: 'custom-classname',
          container: 'body',
          defaultValue: [that.currentPage.value],
          onConfirm: function (result) {
            console.log('当前选中的页面', result);
            that.currentPage = {
              label: result[0].label,
              value: result[0].value
            }
          },
          title: '请添加页面'
        }
      )
    },

    // 添加音色
    addTimbre() {
      let that = this;
      this.$weui.picker(
        that.timbres,
        {
          className: 'custom-classname',
          container: 'body',
          defaultValue: [that.currentTimbre.value],
          onConfirm: function (result) {
            console.log('当前选中的音色', result);
            that.currentTimbre = {
              label: result[0].label,
              value: result[0].value
            }

            that.playTimbre();
          },
          title: '请添加音色'
        }
      )
    },

    playTimbre() {
      getTTSToken().then(res => {
        if (res.data.retcode == 0) {
          let data = res.data.dat
          this.tts_token = data.access_token;
          let timbre = 111;
          if (this.currentTimbre.value) {
            timbre = this.currentTimbre.value
          }
          this.$refs.auido.src = `https://tsn.baidu.com/text2audio?` +
            `tex=${this.selectedCuePhrasesText}` +
            `&tok=${this.tts_token}` +
            `&cuid=${sessionStorage.getItem('openid')}` +
            `&ctp=1&lan=zh&aue=3&per=${timbre}`;
          this.$refs.auido.play();
        }
      })
    },

    // 添加页面参数填写行
    addPageVariableRow() {
      this.pageVariables.push({
        id: uuidv4(),
        name: "",
        value: ""
      })
    }
  }
  ,
}
</script>
<style scoped src="../css/pos_monitor_handler.css">

</style>
<style scoped src="../css/common.css">

</style>



// WEBPACK FOOTER //
// src/views/customer_care_handler.vue